"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _spauiUtils = require("@tencent/spaui-utils");

var _info = _interopRequireDefault(require("./info"));

var _checkbox_props = require("./checkbox_props");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @class
 */
var Checkbox =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Checkbox, _PureComponent);

  function Checkbox(props) {
    var _this;

    _classCallCheck(this, Checkbox);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Checkbox).call(this, props));
    _this.state = {
      checked: props.checked || false
    };
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Checkbox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if ((0, _spauiUtils.isFunction)(_spauiUtils.checkCssVersion)) {
        (0, _spauiUtils.checkCssVersion)(_info["default"]);
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      // 一直响应外部的
      this.setState({
        checked: nextProps.checked || false
      });
    }
  }, {
    key: "handleChange",
    value: function handleChange(event) {
      var _this$props = this.props,
          value = _this$props.value,
          onChange = _this$props.onChange,
          _this$props$isImmedia = _this$props.isImmediatelyRespondChecked,
          isImmediatelyRespondChecked = _this$props$isImmedia === void 0 ? false : _this$props$isImmedia;
      var checked = event.target.checked || false;

      var triggerChange = function triggerChange() {
        if ((0, _spauiUtils.isFunction)(onChange)) {
          onChange(event, checked ? value : '');
        }
      }; // 如果开启了立马响应状态，会先存放在state，然后通过onChange回调传回来最后的结果


      if (isImmediatelyRespondChecked) {
        this.setState({
          checked: checked
        }, function () {
          triggerChange();
        });
      } else {
        triggerChange();
      }
    }
  }, {
    key: "getTipDom",
    value: function getTipDom() {
      var _this$props2 = this.props,
          TipComponent = _this$props2.TipComponent,
          otherProps = _objectWithoutProperties(_this$props2, ["TipComponent"]);

      var result = null;

      if (typeof TipComponent !== 'undefined' && TipComponent) {
        if ((0, _spauiUtils.isFunction)(TipComponent)) {
          result = _react["default"].createElement(TipComponent, otherProps);
        } else {
          result = TipComponent;
        }
      }

      return result;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          textChecked = _this$props3.textChecked,
          iconHtml = _this$props3.iconHtml,
          TextComponent = _this$props3.TextComponent,
          _this$props3$tagName = _this$props3.tagName,
          tagName = _this$props3$tagName === void 0 ? 'label' : _this$props3$tagName;
      var globalPropsData = (0, _spauiUtils.globalProps)(this.props, {
        supportAllEvents: true
      }, Checkbox);
      var result = null;
      var _this$props4 = this.props,
          _this$props4$classNam = _this$props4.className,
          className = _this$props4$classNam === void 0 ? '' : _this$props4$classNam,
          size = _this$props4.size,
          indeterminate = _this$props4.indeterminate,
          disabled = _this$props4.disabled,
          value = _this$props4.value,
          name = _this$props4.name;
      var checked = this.state.checked;
      var TagName = tagName;
      var tagNameProps = {}; // 如果不是label，就得模拟点击事件了

      if (tagName !== 'label' && !disabled) {
        tagNameProps.onClick = function (event) {
          event.target.checked = !checked;
          event.target.value = value;

          _this2.handleChange(event);
        };
      }

      if (textChecked) {
        // 文案可点击选
        result = _react["default"].createElement(TagName, _extends({}, globalPropsData, tagNameProps, {
          className: (0, _classnames["default"])(className, (0, _classnames["default"])('spaui-checkbox', {
            'pre-check': !checked && indeterminate,
            'size-lg': size === 'large',
            'size-xlg': size === 'extralarge'
          }))
        }), _react["default"].createElement("input", {
          type: "checkbox",
          className: "check",
          checked: checked,
          disabled: disabled,
          value: value,
          name: name,
          onChange: this.handleChange
        }), iconHtml, _react["default"].createElement(TextComponent, this.props), this.getTipDom());
      } else {
        result = _react["default"].createElement("div", _extends({}, globalPropsData, {
          className: 'spaui-checkbox-text-unchecked ' + (globalPropsData && globalPropsData.className || '')
        }), _react["default"].createElement(TagName, _extends({}, tagNameProps, {
          className: (0, _classnames["default"])('spaui-checkbox', {
            'pre-check': !checked && indeterminate,
            'size-lg': size === 'large',
            'size-xlg': size === 'extralarge'
          })
        }), _react["default"].createElement("input", {
          type: "checkbox",
          className: "check",
          checked: checked,
          disabled: disabled,
          value: value,
          name: name,
          onChange: this.handleChange
        }), iconHtml), _react["default"].createElement(TextComponent, this.props), this.getTipDom());
      }

      return result;
    }
  }]);

  return Checkbox;
}(_react.PureComponent); // 组件标记


_defineProperty(Checkbox, "propTypes", _checkbox_props.propTypes);

_defineProperty(Checkbox, "defaultProps", _checkbox_props.defaultProps);

(0, _spauiUtils.setComponentMark)(Checkbox, _info["default"]); // 组件上报

(0, _spauiUtils.reportComponentUsage)(_objectSpread({
  scope: 'spaui'
}, _info["default"]));
var _default = Checkbox;
exports["default"] = _default;